export default __webpack_public_path__ + "static/media/maintenanceBg.8a6944c9.png";